// Entry for the watch-together page. The content is static in the HTML, which
// is what makes it crawlable; this exists only to pull in the design tokens
// and the stylesheet.
//
// Without it the page shipped completely unstyled -- Times New Roman and blue
// underlined links -- because a standalone page gets no CSS unless its own
// entry imports it. plus.js does exactly this; I wrote the page without one.
import '@lumi/shared/design-tokens.css';
import './styles.css';
import './watch-together.css';

const yearEl = document.getElementById('year');
if (yearEl) yearEl.textContent = String(new Date().getFullYear());
